"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var paymentTypes = [{
  flag: '',
  title: 'Basic',
  annual: {
    description: '$16.67/month',
    subdescription: '$200/year billed annually',
    price: 200
  },
  monthly: {
    description: '$20/month',
    price: 20
  },
  listOfQualities: ['Mobile Optimized Design', 'Web Hosting', 'Custom Domain', 'Content Editor', 'SSL Security', '+$10/mo for Additional Locations']
}, {
  flag: 'MOST POPULAR',
  title: 'Professional',
  annual: {
    description: '$41.67/month',
    subdescription: '$500/year billed annually',
    price: 500
  },
  monthly: {
    description: '$50/month',
    price: 50
  },
  listOfQualities: ['Everything in Basic, Plus:', 'Dedicated Site Editor', 'Lead Generation', 'ADA Compliance', 'Up to 5 Locations']
}, {
  flag: '',
  title: 'Custom',
  annual: {
    description: '$125/month',
    subdescription: '$1500/year billed annually',
    price: 1500
  },
  monthly: {
    description: '$150/month',
    price: 150
  },
  listOfQualities: ['Everything in Professional, Plus:', 'Personalized Design', 'HD Photography', 'Exclusive Features']
}];
var _default = paymentTypes;
exports["default"] = _default;